import { CheckCircleIcon } from '@heroicons/react/24/outline'
import PropTypes from 'prop-types'

const SuccessPlaceholder = ({ children = null, title, message }) => (
  <div className="flex flex-col items-center pt-6 pb-10 text-center">
    <CheckCircleIcon className="w-40 h-40 text-indigo-800" />
    <h1 className="mt-1 mb-2 text-2xl font-semibold">{title}</h1>
    <p className="max-w-md text-lg text-content2-foreground">{message}</p>

    <div className='w-full'>
      {children && children}
    </div>
  </div>
)

SuccessPlaceholder.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  children: PropTypes.node
}

export default SuccessPlaceholder